import { registerMutation } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
export const SEND_USER_INTERACTION = registerMutation({
  fieldName: 'sendUserInteraction',
  fetcher({
    callbackId,
    userResponse
  }) {
    return http.post('user-interaction-automation-action/v1/interactions', {
      data: {
        callbackId,
        userResponse
      }
    });
  }
});